/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Leave_Window_Open_NoticeInputs */

const en_team_sync_leave_window_open_notice = /** @type {(inputs: Team_Sync_Leave_Window_Open_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please leave this window open until syncing completes`)
};

const fr_team_sync_leave_window_open_notice = /** @type {(inputs: Team_Sync_Leave_Window_Open_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez laisser cette fenêtre ouverte jusqu’à la fin de la synchronisation`)
};

const de_team_sync_leave_window_open_notice = /** @type {(inputs: Team_Sync_Leave_Window_Open_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte lassen Sie dieses Fenster so lange geöffnet, bis die Synchronisierung abgeschlossen ist.`)
};

const it_team_sync_leave_window_open_notice = /** @type {(inputs: Team_Sync_Leave_Window_Open_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si prega di lasciare aperta questa finestra fino al completamento della sincronizzazione`)
};

const ru_team_sync_leave_window_open_notice = /** @type {(inputs: Team_Sync_Leave_Window_Open_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, оставьте это окно открытым до завершения синхронизации.`)
};

const es_team_sync_leave_window_open_notice = /** @type {(inputs: Team_Sync_Leave_Window_Open_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deje esta ventana abierta hasta que se complete la sincronización.`)
};

const zh_cn2_team_sync_leave_window_open_notice = /** @type {(inputs: Team_Sync_Leave_Window_Open_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请保持此窗口打开，直到同步完成。`)
};

const ja_team_sync_leave_window_open_notice = /** @type {(inputs: Team_Sync_Leave_Window_Open_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同期が完了するまでこのウィンドウを開いたままにしてください`)
};

const hi_team_sync_leave_window_open_notice = /** @type {(inputs: Team_Sync_Leave_Window_Open_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया सिंक्रोनाइज़ेशन पूरा होने तक इस विंडो को खुला रखें।`)
};

const pt_pt2_team_sync_leave_window_open_notice = /** @type {(inputs: Team_Sync_Leave_Window_Open_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, deixe esta janela aberta até que a sincronização seja concluída.`)
};

/**
* | output |
* | --- |
* | "Please leave this window open until syncing completes" |
*
* @param {Team_Sync_Leave_Window_Open_NoticeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_leave_window_open_notice = /** @type {((inputs?: Team_Sync_Leave_Window_Open_NoticeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Leave_Window_Open_NoticeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_leave_window_open_notice(inputs)
	if (locale === "de") return de_team_sync_leave_window_open_notice(inputs)
	if (locale === "it") return it_team_sync_leave_window_open_notice(inputs)
	if (locale === "ru") return ru_team_sync_leave_window_open_notice(inputs)
	if (locale === "es") return es_team_sync_leave_window_open_notice(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_leave_window_open_notice(inputs)
	if (locale === "ja") return ja_team_sync_leave_window_open_notice(inputs)
	if (locale === "hi") return hi_team_sync_leave_window_open_notice(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_leave_window_open_notice(inputs)
	return en_team_sync_leave_window_open_notice(inputs)
});